import { SidebarMobileTriggerBar } from "components/sidebar/SidebarMobileTrigger";
import {
  SIDEBAR_CONTENT_CLASSES,
  SIDEBAR_STYLE,
} from "components/sidebar/sidebarShell";
import {
  Sidebar,
  SidebarContent,
  SidebarProvider,
  useSidebar,
} from "components/ui/sidebar";

function SidebarShell({ sidebar, content, mobileMenuLabel }) {
  const { isMobile } = useSidebar();

  return (
    <>
      {/* The desktop rail is static. Mobile needs a sheet, which the primitive
          only renders for a collapsible rail, so force one below the breakpoint. */}
      <Sidebar
        collapsible={isMobile ? "offcanvas" : "none"}
        className="tw:shrink-0"
        role="navigation"
        aria-label={mobileMenuLabel ?? "Section navigation"}
      >
        <SidebarContent className={SIDEBAR_CONTENT_CLASSES}>
          {sidebar}
        </SidebarContent>
      </Sidebar>
      <div className="tw:flex tw:min-h-0 tw:min-w-0 tw:flex-1 tw:flex-col">
        <SidebarMobileTriggerBar label={mobileMenuLabel} />
        <div className="tw:flex tw:min-h-0 tw:min-w-0 tw:flex-1 tw:flex-col tw:overflow-y-auto tw:p-6">
          {content}
        </div>
      </div>
    </>
  );
}

// Static secondary-sidebar shell: a rail slot beside a content slot.
export default function SidebarLayout({ sidebar, content, mobileMenuLabel }) {
  return (
    <SidebarProvider
      // Claim a height and clip, or the flex column collapses to its content.
      className="tw:h-full tw:min-h-0 tw:min-w-0 tw:flex-1 tw:overflow-hidden"
      style={SIDEBAR_STYLE}
    >
      <SidebarShell
        sidebar={sidebar}
        content={content}
        mobileMenuLabel={mobileMenuLabel}
      />
    </SidebarProvider>
  );
}
